<template>
  <v-app>
    <v-app-bar app color="primary" dark>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"/>
      <div class="d-flex align-center">
        <b>GUIZMO HOME</b>
      </div>
      <v-spacer></v-spacer>
    </v-app-bar>
    <NavigationDrawer :drawer="drawer" @onDrawerHide="drawer = false"></NavigationDrawer>
    <v-content>
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
import NavigationDrawer from './components/NavigationDrawer';

export default {
  name: 'App',
  components: {
    NavigationDrawer
  },

  data: () => ({
    drawer: false,
    items: [
      { title: 'Dashboard', icon: 'mdi-view-dashboard' },
      { title: 'Configuration', icon: 'mdi-cogs' },
      { title: 'Developer Tool', icon: 'mdi-code-braces' }
    ]
  }),

  methods: {
  }
};
</script>
